"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementListItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const GenericListItem_1 = require("../../../components/mobile-view/mobile-list/GenericListItem");
const SettlementListItem = ({ settlement }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const handlerGotoDetail = () => navigate(`/settlement/${settlement.id}`);
    return ((0, jsx_runtime_1.jsx)(GenericListItem_1.GenericListItem, { title: settlement.clubName, subtitle: settlement.machineName, labels: {
            leftLabel: t('invoice'),
            leftValue: settlement.settlementNumber,
            rightLabel: t('period'),
            rightValue: `${settlement.billingPeriod?.startDate} - ${settlement.billingPeriod?.endDate}`,
        }, date: settlement.issueDate, amount: settlement.netPayout, onClick: handlerGotoDetail }));
};
exports.SettlementListItem = SettlementListItem;
